import { useEffect } from "react";
import "./documents.scss";

import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { selectorDocuments } from "src/storage";

export const useDocuments = () => {
  const { t } = useTranslation();

  let documents = useRecoilValue(selectorDocuments);

  documents = documents?.filter((doc) => doc?.docCode !== '9');

  const openDocument = (link = "") => {
    if (link) {
      window.open(link?.replaceAll('"', "").toString(), "_blank");
    }
  };

  return {
    t,
    documents,
    openDocument,
  };
};
